import { types } from "../Actions/types";
// import { cloneDeep, merge } from "lodash";


const initialState = {
    userProfile: {}
};

const UserProfileReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.USER_PROFILE:
            return {
                ...state,
               userProfile: payload,
            };

        default:
            return state;
    }
};

export default UserProfileReducer;
